"use strict";
exports.__esModule = true;
exports.forTime = void 0;
function forTime(miliseconds) {
    return new Promise(function (resolve) {
        setTimeout(function () {
            resolve();
        }, miliseconds);
    });
}
exports.forTime = forTime;
